import BaseModel from './base.model';

class InvoiceModel extends BaseModel {
  public customerNumber: string = '';
  public description: string = '';
  public dueDate: string = '';
  public hasInvoice: boolean = false;
  public invoiceDate: string = '';
  public invoiceNumber: number = 0;
  public orderNumber: number = 0;
  public remainingAmount: number = 0;
  public status: 'PAID' | 'DUE' | 'PAST DUE' | 'PENDING' | 'IN PROCESS';
  public transactionId: number = 0;
  public idx: string = '';
}

export default InvoiceModel;
